module.exports = __webpack_public_path__ + "img/LaCasaDeToño-G.285b05cc.png";